import { gql } from '@apollo/client';

/** 批次简要信息（后端 BatchBriefType）；status 为批次状态枚举名 */
export interface BatchBriefApi {
    id: number;
    batchName: string;
    status: string;
    /** 目的地：Hub 或 Hub-WHS（如 LA-SAN） */
    destination: string;
}

const BATCH_BRIEF_FIELDS = 'id batchName status destination';

/** 移入无法执行的原因（后端 MoveInRejectReasonType） */
export type MoveInRejectReasonApi =
    | 'PARCEL_NOT_SUPPORTED' | 'INVALID_NUMBER' | 'BAG_NOT_FOUND' | 'BAG_IN_BAGGING_TASK'
    | 'FLOW_BATCH_CLOSED' | 'NO_OTHER_SAME_FLOW' | 'NO_MATCHING_FLOW' | 'SOURCE_BATCH_COMPLETED'
    | 'BAG_BUSINESS_TYPE_NOT_SUPPORTED' | 'BAG_DISCARDED' | 'BAG_HANDED_OVER' | 'BAG_UNUSED';

/** 可移入的包牌（按包牌一项）；候选批次后端已排序，不含当前所属批次 */
export interface MoveInBagItemApi {
    bagNumber: string;
    sortingCode: string | null;
    destination: string | null;
    parcelCount: number;
    currentBatches: BatchBriefApi[];
    candidates: BatchBriefApi[];
}

export interface MoveInOrphanApi {
    number: string;
    reason: MoveInRejectReasonApi;
    currentBatch: BatchBriefApi | null;
}

export interface PreviewSortingBatchMoveInData {
    previewSortingBatchMoveIn: {
        items: MoveInBagItemApi[];
        orphans: MoveInOrphanApi[];
    };
}

export const PREVIEW_SORTING_BATCH_MOVE_IN = gql`
    query PreviewSortingBatchMoveIn($warehouseId: Long!, $numbers: [String!]!) {
        previewSortingBatchMoveIn(warehouseId: $warehouseId, numbers: $numbers) {
            items {
                bagNumber
                sortingCode
                destination
                parcelCount
                currentBatches { ${BATCH_BRIEF_FIELDS} }
                candidates { ${BATCH_BRIEF_FIELDS} }
            }
            orphans {
                number
                reason
                currentBatch { ${BATCH_BRIEF_FIELDS} }
            }
        }
    }
`;

/** 移出无法执行的原因（后端 MoveOutRejectReasonType） */
export type MoveOutRejectReasonApi =
    | 'INVALID_NUMBER' | 'BAG_NOT_FOUND' | 'NOT_IN_ANY_BATCH' | 'BATCH_COMPLETED' | 'BATCH_CANCELLED' | 'BAG_IN_BAGGING_TASK'
    | 'BAG_DISCARDED' | 'BAG_UNUSED';

export interface MoveOutItemApi {
    number: string;
    isBag: boolean;
    bagNumber: string | null;
    destination: string | null;
    currentBatch: BatchBriefApi;
    parcelCount: number;
}

export interface MoveOutRejectedApi {
    number: string;
    reason: MoveOutRejectReasonApi;
    currentBatch: BatchBriefApi | null;
}

export interface PreviewSortingBatchMoveOutData {
    previewSortingBatchMoveOut: {
        items: MoveOutItemApi[];
        rejected: MoveOutRejectedApi[];
    };
}

export const PREVIEW_SORTING_BATCH_MOVE_OUT = gql`
    query PreviewSortingBatchMoveOut($warehouseId: Long!, $numbers: [String!]!) {
        previewSortingBatchMoveOut(warehouseId: $warehouseId, numbers: $numbers) {
            items {
                number
                isBag
                bagNumber
                destination
                currentBatch { ${BATCH_BRIEF_FIELDS} }
                parcelCount
            }
            rejected {
                number
                reason
                currentBatch { ${BATCH_BRIEF_FIELDS} }
            }
        }
    }
`;
